import PropTypes from "prop-types";
import { useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import { AppBar, Box, Toolbar, Typography, useMediaQuery } from "@mui/material";
import AppBarStyled from "./AppBarStyled";
import HeaderContent from "./HeaderContent";
import IconButton from "components/@extended/IconButton";
import { DRAWER_WIDTH } from "config";
import { HambergerMenu } from "iconsax-react";
// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = ({ open, handleDrawerToggle, setOpen }) => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));
  // header content
  const headerContent = useMemo(() => <HeaderContent setOpen={setOpen} />, []);

  const iconBackColorOpen = "secondary.200";
  const iconBackColor = "secondary.100";
  const sicpaMain = "#222222";

  // common header
  const mainHeader = (
    <Toolbar
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        minHeight: "56px !important",
        px: {
          xs: 1.5,
          sm: 1.5,
          md: open ? 2 : 4,
          lg: open ? 2 : 8,
        },
        py: 0,
        boxShadow: "rgba(17, 17, 26, 0.1) 0px 1px 0px",
      }}
    >
      {downLG || open ? (
        <IconButton
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          edge="start"
          color="secondary"
          variant="light"
          size="large"
          sx={{
            color: "#02462E",
            ml: { xs: 0, lg: 0 },
            p: 1,
          }}
        >
          <HambergerMenu />
        </IconButton>
      ) : null}
      <Typography
        variant="h1"
        sx={{
          color: "#02462E",
          marginLeft: { xs: 0.5, sm: 1, lg: 1.5 },
          fontFamily: "Poppins",
          fontWeight: 800,
          fontSize: { xs: "12px", sm: "13px", lg: "16px" },
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          lineHeight: 1.2,
          flexShrink: 1,
        }}
      >
        AI-Powered  <span style={{ color: "#FEC700" }}> ESG Reporting {" "}</span>
         across Global, National, Sectoral, and Industry-Specific Standards
      </Typography>
      <Box sx={{ flexGrow: 1, minWidth: 0 }} />
      <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
        {headerContent}
      </Box>
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: "fixed",
    elevation: 0,
    sx: {
      bgcolor: "#ffffff",
      backdropFilter: "blur(8px)",
      zIndex: 1200,
      width: open ? `calc(100% - ${DRAWER_WIDTH}px)` : "100%",
    },
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

Header.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  setOpen: PropTypes.func,
};

export default Header;
